import Vue from 'vue'
import Router from 'vue-router'
// import Article from '@/components/article/Article'
import Loading from '@/components/loading/Loading'
import Race from '@/components/race/Race'
import Result from '@/components/result/Result'
// import Share from '@/components/share/Share'
import {service as AnalyticsService} from 'src/api/AnalyticsService'
import api from 'src/config/api'
import config from 'src/../config'
import 'url-search-params-polyfill'
import Cookies from 'js-cookie'
import store from 'src/store'
window.Cookies = Cookies

Vue.use(Router)

let base = __dirname
if (process.env.NODE_ENV === 'production') {
  base = config.build.assetsPublicPath
}


const router = new Router({
  mode: 'history',
  base: base,
  routes: [
    // {
    //   path: '/',
    //   name: 'article',
    //   component: Article
    // },
    {
      path: '/',
      name: 'loading',
      component: Loading
    },
    {
      path: '/race',
      name: 'race',
      component: Race
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
export default router




// AUTO ANALYTICS HOOK (Dont use, do manually instead)
// router.afterEach((to, from)=> {
//   AnalyticsService.sendPageview(to.fullPath)
// })



// GUARD FROM GOING DIRECTLY TO RESULTS PAGE
// import store from 'src/store'
router.beforeEach((to, from, next)=> {

  // if (to.name === 'results' && !store.state.game.time) {
  //   next({name: 'article'})
  //   return
  // }


  // WECHAT REDIRECT
  // if (to.name === 'loading') {

  //   const isWechat = /micromessenger/i.test(navigator.userAgent)
  //   const urlParams = new window.URLSearchParams(window.location.search)
  //   const username = urlParams.get('_username') || Cookies.get('_username')

  //   if (isWechat) {

  //     // NO USERNAME, REDIRECT
  //     if (username === null || username === undefined) {
  //       Cookies.set('_username', '')
  //       const redirect = `${api.endpoints.getOpenId}?callback=${window.location.origin}${config.build.assetsPublicPath}`
  //       window.location.replace(redirect)

  //     // ALREADY HAVE USERNAME
  //     } else {
  //       Cookies.set('_username', username)
  //       store.commit('wechat/setUsername', username)
  //     }

  //   }
  // }

  if (to.name === 'race') {
    if (!store.state.game.loading.completed) {
      return next({name: 'loading'})
    }
  }

  // NEXT
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js